import {I18nFunction} from '../i18n/i18n';
import {CurrencyUnit} from '../models/interfaces';

export function formatCurrency(t: I18nFunction, locale: string, value: number, unit: CurrencyUnit): string {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: unit.toUpperCase(),
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  } catch (_err) {
    return t({
      type: 'ValueUnit',
      val: value,
      unit: unit,
    });
  }
}
